import React, { useState } from 'react'
import { withRouter } from 'react-router-dom'
import { DataTableSortableHeader } from '@softwaredev_cegeka/stix-data-table'
import { Menu } from '@softwaredev_cegeka/stix-core/dist/components'
import {
    debouncedLoadData,
    sortData,
    sortObjectToString,
} from 'src/utils/utils'
import EntityTable from './EntityTable'
import './entityTable.scss'

/**
 * User table content.
 * @param props
 * @returns {*}
 * @constructor
 */
function UserSessionTable(props) {
    const {
        data,
        rowSelectHandler,
        setParams,
        params,
        deleteAction,
        isGlobalAdmin,
        ...rest
    } = props
    const [sort, setSort] = useState({ column: null, direction: null })
    const columns = [
        {
            Header: () => {
                return (
                    <DataTableSortableHeader
                        sorted={
                            sort.column === 'username'
                                ? sort.direction
                                : undefined
                        }
                        onSort={handleColumnSort('username')}
                    >
                        Username
                    </DataTableSortableHeader>
                )
            },
            accessor: 'username',
            width: '10%',
        },
        {
            Header: () => {
                return (
                    <DataTableSortableHeader
                        sorted={
                            sort.column === 'first_name'
                                ? sort.direction
                                : undefined
                        }
                        onSort={handleColumnSort('first_name')}
                    >
                        First Name
                    </DataTableSortableHeader>
                )
            },
            accessor: 'first_name',
            width: '10%',
        },
        {
            Header: () => {
                return (
                    <DataTableSortableHeader
                        sorted={
                            sort.column === 'last_name'
                                ? sort.direction
                                : undefined
                        }
                        onSort={handleColumnSort('last_name')}
                    >
                        Last Name
                    </DataTableSortableHeader>
                )
            },
            accessor: 'last_name',
            width: '10%',
        },
        {
            Header: () => {
                return (
                    <DataTableSortableHeader
                        sorted={
                            sort.column === 'email' ? sort.direction : undefined
                        }
                        onSort={handleColumnSort('email')}
                    >
                        Email
                    </DataTableSortableHeader>
                )
            },
            accessor: 'email',
            width: '20%',
        },
        {
            Header: () => {
                return (
                    <DataTableSortableHeader
                        sorted={
                            sort.column === 'request_datetime'
                                ? sort.direction
                                : undefined
                        }
                        onSort={handleColumnSort('request_datetime')}
                    >
                        Request Datetime
                    </DataTableSortableHeader>
                )
            },
            accessor: 'request_datetime',
            width: '9%',
        },
        {
            Header: () => {
                return (
                    <DataTableSortableHeader
                        sorted={
                            sort.column === 'refresh_token_expiration_datetime'
                                ? sort.direction
                                : undefined
                        }
                        onSort={handleColumnSort(
                            'refresh_token_expiration_datetime'
                        )}
                    >
                        Expiration Datetime
                    </DataTableSortableHeader>
                )
            },
            accessor: 'refresh_token_expiration_datetime',
            width: '10%',
        },
        {
            Header: () => {
                return (
                    <DataTableSortableHeader
                        sorted={
                            sort.column === 'agent_type'
                                ? sort.direction
                                : undefined
                        }
                        onSort={handleColumnSort('agent_type')}
                    >
                        User Agent Type
                    </DataTableSortableHeader>
                )
            },
            accessor: 'agent_type',
            width: '21%',
        },
    ]
    const columnsToFilter = [
        {
            column: 'username',
            label: 'username',
        },
        {
            column: 'first_name',
            label: 'first name',
        },
        {
            column: 'last_name',
            label: 'last name',
        },
        {
            column: 'email',
            label: 'email',
        },
        {
            column: 'agent_type',
            label: 'agent type',
        },
    ]

    const handleColumnSort = columnName => sortingDirection => {
        sortData(columnName, sortingDirection, params, setSort, setParams)
    }

    if (isGlobalAdmin) {
        columns.push({
            Header: () => null,
            id: 'menu',
            Cell: selectedRow => (
                <Menu.Option
                    contextMenu={[
                        {
                            name: 'Remove',
                            icon: 'delete',
                            onClick: () => {
                                let r = window.confirm(
                                    `You are permanently removing user session ${selectedRow.row.original.username} ${selectedRow.row.original.agent_type}. Are you sure?`
                                )
                                if (r === true) {
                                    deleteAction(selectedRow.row.original.id)
                                }
                            },
                        },
                    ]}
                    icon={'actions-vert'}
                />
            ),
            width: '1%',
        })
    }

    function handleFilterChange(entries) {
        // Reset to show all results after clear filters is clicked.
        if (entries.length === 0) {
            setParams({})
            return
        }

        const sortString = sortObjectToString(sort)

        // Update params with new selected filter and send them back to the route.
        entries.forEach(item => {
            Object.entries(item).forEach(([key, value]) => {
                params[key + '_like'] = value.toString()
            })
        })

        if (sortString) {
            params.sort = sortString
        }

        setParams(params)
    }

    function handleGlobalFilter(value) {
        // check all columns on entry
        params['search'] = value.toString()
        debouncedLoadData(params, setParams)
    }

    return (
        <EntityTable
            {...rest}
            onSingleRowSelect={selectedRowObj => {
                rowSelectHandler(selectedRowObj)
            }}
            data={data}
            columns={columns}
            columnsTofilter={columnsToFilter}
            onColumnFilter={handleFilterChange}
            onGlobalFilter={handleGlobalFilter}
        />
    )
}

export default withRouter(UserSessionTable)
